<i18n src="@/locales/models/order.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/order_item.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_order.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_orders')"
    :params="{
      service_provider_id: service_provider_id,
      delivery_process_id: delivery_process_id
    }"
  />

  <bread-crumbs
    :labels="[module_name, delivery_process?.name, order?.order_code]"
  />

  <template v-if="load_general_data">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.order.order_code") }}
                </dt>
                <dd class="content-data">
                  {{ order.order_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.order.ordered_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(order.ordered_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.order.delivery_process_customer") }}
                </dt>
                <dd class="content-data">
                  {{ order.delivery_process_customer.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.order.status") }}
                </dt>
                <dd class="content-data">
                  <span
                    :class="[
                      'inline-flex items-center px-2 py-0.5 rounded text-sm font-medium',
                      $t(`model.order.statuses.${order.status}.text`),
                      $t(`model.order.statuses.${order.status}.bg`)
                    ]"
                  >
                    {{ $t(`model.order.statuses.${order.status}.label`) }}
                  </span>
                </dd>
              </div>
            </div>

            <div class="panel">
              <div class="panel-header">
                <h3 class="panel-header-title">
                  {{ $t("labels.items") }}
                </h3>
              </div>
              <div class="panel-body">
                <div class="space-y-8 divide-y divide-gray-200">
                  <div
                    v-for="(order_item, index) in order.order_items"
                    class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                    :key="index"
                  >
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.order_item.delivery_product") }}
                      </dt>
                      <dd class="content-data">
                        {{ order_item.delivery_product.crop.name }}
                        ({{ order_item.delivery_product.unit_of_measure }})
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.order_item.quantity") }}
                      </dt>
                      <dd class="content-data">
                        {{ order_item.quantity }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.order_item.unit_price") }}
                      </dt>
                      <dd class="content-data">
                        S/ {{ order_item.unit_price }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.order_item.total_price") }}
                      </dt>
                      <dd class="content-data">
                        S/ {{ order_item.total_price }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.order_item.quantity_delivered") }}
                      </dt>
                      <dd class="content-data">
                        {{ order_item.quantity_delivered }}
                      </dd>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button
              @click.prevent="cancelOrder"
              :label="$t('labels.cancel_button')"
            />
            <span class="space-actions"></span>
            <destroy-button
              v-if="!proc_button_destroy"
              :disabled_button="false"
              @destroyEvent="destroy"
              :label="$t('labels.destroy_button_label')"
              :title="
                $t('labels.destroy_button_title', { code: order.order_code })
              "
              :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')"
            />
            <destroy-button-processing
              v-else
              :label="$t('labels.destroy_button_label')"
            />
            <span class="space-actions"></span>
            <edit-button @click.prevent="goToEditOrder" label="Editar" />
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/show_order.js";
import ManageRequester from "@/views/service_provider/requesters/delivery/managing/manage_orders.js";
export default {
  name: "SPDeliveryManagingShowOrder",
  components: {},
  data() {
    return {
      load_general_data: false,
      proc_button_destroy: false,
      delivery_process: {},
      order: {}
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
    id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id
        }
      }).then(() => this.loadData())
    );
  },
  computed: {},
  methods: {
    loadData: async function () {
      await this.fetchDeliveryProcess();
      await this.fetchOrder();
      this.load_general_data = true;
    },

    fetchDeliveryProcess: async function () {
      const response = await Requester.fetchDeliveryProcess(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_process = response.data;
    },

    destroy: async function () {
      try {
        let response = await ManageRequester.destroy(
          this.service_provider_id,
          this.delivery_process_id,
          this.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
    },

    cancelOrder: async function () {
      try {
        let response = await ManageRequester.update(
          this.service_provider_id,
          this.delivery_process_id,
          this.id,
          { status: "cancelled" }
        );

        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.order.status = "cancelled";
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
    },

    fetchOrder: async function () {
      const response = await Requester.fetchOrder(
        this.service_provider_id,
        this.delivery_process_id,
        this.id
      );

      this.order = response.data;
    },

    goToEditOrder: function () {
      this.$router.push({
        name: this.routeName("edit_order"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
          id: this.id
        }
      });
    },

    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id
        }
      });
    }
  },
  watch: {}
};
</script>
